/**
 * ChatInput (Sprint 7 B5).
 *
 * Textarea + Send button. Enter = send, Shift+Enter = newline.
 * Auto-grow tới max 4 lines. Disabled khi streaming.
 */

import { useState, type ChangeEvent, type KeyboardEvent } from "react";
import { Button, Input, Space } from "antd";
import { SendOutlined } from "@ant-design/icons";

const { TextArea } = Input;

interface Props {
  onSend: (text: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function ChatInput({ onSend, disabled = false, placeholder }: Props) {
  const [text, setText] = useState("");

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      style={{
        padding: 12,
        borderTop: "1px solid #f0f0f0",
        background: "#fff",
      }}
    >
      <Space.Compact style={{ width: "100%" }}>
        <TextArea
          data-testid="chat-input"
          value={text}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setText(e.target.value)
          }
          onKeyDown={handleKeyDown}
          placeholder={placeholder ?? "Hỏi AI Tutor... (Enter để gửi, Shift+Enter xuống dòng)"}
          autoSize={{ minRows: 1, maxRows: 4 }}
          disabled={disabled}
        />
        <Button
          data-testid="chat-send-btn"
          type="primary"
          icon={<SendOutlined />}
          onClick={handleSend}
          disabled={disabled || !text.trim()}
        >
          Gửi
        </Button>
      </Space.Compact>
    </div>
  );
}
